
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AdminLayout from './AdminLayout';

interface AdminRouteProps {
  children: React.ReactNode;
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  // Show a loading spinner while auth state is being resolved
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A0E1A] flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-12 h-12 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin"></div>
          <p className="text-sm text-white/60">Verificando acesso...</p>
        </div>
      </div>
    );
  }

  // If the user is not logged in, redirect to the admin login page
  if (!isAuthenticated) {
    return <Navigate to="/login-admin" replace />;
  }

  // If the user is logged in but not an admin, redirect to a safe dashboard
  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  // All checks passed – render the protected admin layout
  return <AdminLayout>{children}</AdminLayout>;
}
